import { gql } from "@apollo/client";

const FEEDBACK_FOR_ORGANIZATION = gql`
  query FeedbackForOrganizationPrismaProxy(
    $input: FeedbackForOrganizationInputPrismaProxy!
  ) {
    feedbackForOrganizationPrismaProxy(input: $input) {
      stats
      success
      organization {
        id
        enableNPS
      }
    }
  }
`;

export default FEEDBACK_FOR_ORGANIZATION;
